import { Navigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../routes/vendor/vendorRoutes";
import authManager from "../utils/vendor/authManager";

const VendorAuth = ({ children }) => {
  if (authManager.hasVendorAccessToken()) {
    return children;
  } else {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }
};

export default VendorAuth;
